// src/lib/argent-lecture.js — UNE LECTURE RATÉE S'AFFICHE « — », JAMAIS 0.
//
// ══ POURQUOI (F13, 2026-10-02) ══════════════════════════════════════════════
//
// Quand la lecture des données de facturation échoue (503 au chargement,
// réponse illisible, réseau), l'écran garde un blob VIDE en mémoire. Tout ce
// qui se calcule dessus vaut alors 0 : « Total à facturer 0.00 € »,
// « Occupation 0 % », « 0 » incident. Ces zéros ne sont pas des zéros — c'est
// « je ne sais pas » (noyau 10 : « 0 » = zéro, « — » = je ne sais pas).
//
// Une seule source pour savoir si la lecture a raté : le bandeau de lecture
// lui-même. Il est posé au chargement quand la lecture échoue, et retiré dès
// qu'une relecture adopte des données (cf. `appliquerRelecture`) — l'écran
// repasse alors aux vrais chiffres sans rien de plus.
//
// ⚠️ AFFICHAGE SEULEMENT. Aucun calcul d'argent ne passe par ici : `calc`,
// les factures et les écritures restent intouchés.

import {
  MESSAGE_DATA_LECTURE_IMPOSSIBLE,
  MESSAGE_DATA_ILLISIBLE,
} from "./data-api";
import { MONTANT_INCALCULABLE } from "./format";

/** Vrai si le bandeau dit que les données de facturation n'ont pas été lues. */
export function lectureArgentRatee(messages) {
  const liste = Array.isArray(messages) ? messages : [];
  return (
    liste.includes(MESSAGE_DATA_LECTURE_IMPOSSIBLE) ||
    liste.includes(MESSAGE_DATA_ILLISIBLE)
  );
}

/**
 * La valeur si les données ont été lues, « inconnue » (NaN) sinon. NaN est ce
 * que les formats de l'écran savent déjà afficher « — » (`fmtE`, paquet argent
 * 2026-09-03) — aucun nouveau langage d'affichage.
 */
export function siLu(ratee, valeur) {
  return ratee ? NaN : valeur;
}

/** « 71 % », ou « — » pour une valeur inconnue (0 reste « 0 % »). */
export function fmtPourcent(v) {
  return Number.isFinite(v) ? `${v} %` : MONTANT_INCALCULABLE;
}

/** Un compte tel quel, ou « — » pour une valeur inconnue (0 reste 0). */
export function fmtCompte(v) {
  return Number.isFinite(v) ? v : MONTANT_INCALCULABLE;
}

/**
 * Relecture argent (F13 suite) : texte des boutons « Envoyer par Gmail » et
 * « Générer la facture », DÉSACTIVÉS quand les données de facturation n'ont
 * pas été lues (sinon : vrai numéro P + vrai courriel calculés sur un vide).
 * Texte choisi par Dimitri (2026-10-03).
 */
export const TEXTE_FACTURE_LECTURE_RATEE =
  "Données pas encore chargées — rechargez la page";
